/** @format */

import email from "../assets/email.webp";
import mobile from "../assets/mobile.webp";
import api from "../assets/api.webp";
import cpp from "../assets/cpp.webp";
import css from "../assets/css.webp";
import figma from "../assets/figma.webp";
import flutter from "../assets/flutter.webp";
import git from "../assets/git.webp";
import graphql from "../assets/graphql.webp";
import html from "../assets/html.webp";
import javascript from "../assets/javascript.webp";
import mu5 from "../assets/mu5.webp";
import node from "../assets/node.webp";
import python from "../assets/python.webp";
import react from "../assets/react.webp";
import next from "../assets/next.webp";
import redux from "../assets/redux.webp";
import sass from "../assets/sass.webp";
import typescript from "../assets/typescript.webp";
import vue from "../assets/vue.webp";
import sanity from "../assets/sanity.svg";

import about01 from "../assets/about01.webp";
import about02 from "../assets/about02.webp";
import about03 from "../assets/about03.webp";
import about04 from "../assets/about04.webp";

import profile from "../assets/profile.webp";
import circle from "../assets/circle.svg";
import logo from "../assets/logo.webp";

import adidas from "../assets/adidas.webp";
import amazon from "../assets/amazon.webp";
import asus from "../assets/asus.webp";
import bolt from "../assets/bolt.webp";
import nb from "../assets/nb.webp";
import skype from "../assets/skype.webp";
import spotify from "../assets/spotify.webp";

import sun from "../assets/sun.webp";
import moon from "../assets/moon.webp";

// eslint-disable-next-line import/no-anonymous-default-export
export default {
  email,
  mobile,
  api,
  cpp,
  css,
  figma,
  flutter,
  git,
  graphql,
  html,
  javascript,
  mu5,
  node,
  python,
  react,
  next,
  redux,
  sass,
  typescript,
  vue,
  about01,
  about02,
  about03,
  about04,
  profile,
  circle,
  logo,
  adidas,
  amazon,
  asus,
  bolt,
  nb,
  skype,
  spotify,
  sanity,
  sun,
  moon
};
